export const rnpSubmitButtonSx = (theme) => ({
  minWidth: 120,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    WebkitTextFillColor: theme.palette.primary.contrastText,
    opacity: 0.55,
  },
});
